import { config } from '../config.js'
import { get, post, put } from '../services/http.js'
import { OutOfStockException } from '../services/stripe.js'
import { validateAddresses } from '../services/utilities.js'

export let getUserOrders = async function (page, limit) {
  let url = `${config.apiUrl}/orders/user?limit=${limit}&page=${page}`
  return await get(url)
}

export let getUserSubscription = async function () {
  let url = `${config.apiUrl}/account/subscription`
  return await get(url)
}

export let pauseSubscription = async function (userId) {
  let url = `${config.apiUrl}/account/subscription`
  let body = JSON.stringify({ deactivate: true })
  let result = await put(url, body)
  return result
}

export let cancelSubscription = async function (userId) {
  let url = `${config.apiUrl}/account/subscription`
  let body = JSON.stringify({ cancel: true })
  let result = await put(url, body)
  return result
}

export let changeSubscriptionPlan = async function (sku) {
  let url = `${config.apiUrl}/account/subscription`
  let body = JSON.stringify({
    update: true,
    plan_sku: sku,
  })
  let result = await put(url, body)
  return result
}

export let renewSubscription = async function (userId) {
  let url = `${config.apiUrl}/account/subscription/renew`
  let result = await post(url, null)
  return result
}

export let getOrderBySession = async function (id) {
  let url = `${config.apiUrl}/order/session/${id}`
  return await get(url)
}

export let checkSession = async function (session_id) {
  let data = JSON.stringify({
    session_id,
    delete_if_incomplete: true,
  })
  let url = `${config.apiUrl}/session/check`
  return await post(url, data)
}

export let getShippingRates = async function (order, cart) {
  let data = JSON.stringify({
    products: cart,
    destination_city: order.details.shipping.city,
    destination_state: order.details.shipping.state,
    destination_address_line_1: order.details.shipping.address,
    destination_address_line_2: order.details.shipping.address2,
    destination_postal_code: order.details.shipping.zip,
  })
  let url = `${config.apiUrl}/rates`
  let resp = await post(url, data)

  if (resp.rates && resp.rates !== null) {
    let rates = resp.rates.sort((a, b) => {
      return a.shipment_charge_total_int - b.shipment_charge_total_int
    })

    return [rates[0]]
  }

  return null
}

export let getTaxes = async function (products, details) {
  let url = `${config.apiUrl}/taxes`

  let data = JSON.stringify({
    checkout: false,
    products: products,
    ...details,
  })
  let resp = await post(url, data, null, true)

  if (resp && resp.taxes >= 0) {
    return resp
  }
  // todo: should we return an error to alert us
  return { fees: [], taxes: 0 }
}

export let validateOrder = async function (products, details) {
  let url = `${config.apiUrl}/cart/checkout`
  let prods = products.map((p) => {
    return {
      id: p.id,
      quantity: p.quantity,
      event_id: p.event_id,
    }
  })
  let data = JSON.stringify({ checkout: false, products: prods, ...details })
  let response = await post(url, data, null, true)

  if (
    response.out_of_stock_products &&
    response.out_of_stock_products.length > 0
  ) {
    return {
      error:
        'Sorry! Some items in your cart may be unavailable or out of stock now.',
    }
  }
  return response
}

export let getSessionID = async function (products, details) {
  let url = `${config.apiUrl}/cart/checkout`

  if (details.discounts && details.discounts.total) {
    details.discounts.total = parseInt(details.discounts.total)
  }
  let body = JSON.stringify({ checkout: true, products, ...details })
  let data = await post(url, body)
  if (data.out_of_stock_products && data.out_of_stock_products.length > 0) {
    throw new OutOfStockException(
      'Sorry! Some items in your cart may be out of stock now',
      data.order_products,
      data.out_of_stock_products,
    )
  }
  return {
    sessionID: data.stripe_session_id,
    redirectToCheckout: data.redirect,
  }
}

export let validateAddress = async function (shipAddress) {
  let data = {
    address: shipAddress.address,
    address2: shipAddress.address2,
    city: shipAddress.city,
    state: shipAddress.state,
    country: 'US',
    zip: shipAddress.zip,
  }

  let url = `${config.apiUrl}/validate/address`
  let body = JSON.stringify(data)

  let result = await post(url, body, 'application/json', true)

  if (result.error) {
    return {
      error: result.error,
    }
  }

  return {
    addressStruct: {
      ...shipAddress,
      address: result.address,
      address2: result.address2,
      city: result.city,
      state: result.state,
      zip: result.zip,
    },
    address: `${result.address} ${result.address2} ${result.city}, ${result.state} ${result.zip}`,
    valid: validateAddresses(shipAddress, result),
  }
}
